import { render, staticRenderFns } from "./FormInputGender.vue?vue&type=template&id=06614704&lang=pug"
import script from "./FormInputGender.vue?vue&type=script&lang=ts"
export * from "./FormInputGender.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports